const Reflux = require("reflux");
const WinRateActions = require("../actions/win-rate-actions");

const WinRateStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      won: {
        count: 0,
        totalAmount: 0
      },
      lost: {
        count: 0,
        totalAmount: 0
      },
      countPercentage: 0,
      countPercentageDelta: 0,
      totalAmountPercentage: 0,
      totalAmountPercentageDelta: 0
    }
  },

  init: function() {
    this.listenTo(WinRateActions.fetchData, this.onFetchStarted);
    this.listenTo(WinRateActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(WinRateActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        won: {
          count: data.won.count,
          totalAmount: data.won.total_amount
        },
        lost: {
          count: data.lost.count,
          totalAmount: data.lost.total_amount
        },
        countPercentage: data.count_percentage.value,
        countPercentageDelta: data.count_percentage.delta,
        totalAmountPercentage: data.total_amount_percentage.value,
        totalAmountPercentageDelta: data.total_amount_percentage.delta
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function() {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
})

module.exports = WinRateStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/win-rate-store.js